import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";
import VirtualizedTable from "../../../components/common/virtualized-table";
import _ from "lodash";
import {List} from "immutable";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Actions
import {getUsers, changeUserStatus, changeUserPassword, cleanUsers} from "../../../actions/users";

// Dialogs
import UserChangePasswordDialog from '../../../components/dialogs/UserChangePasswordDialog';


class UsersPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            usersFilter: '',
            canSubmit: false,
            modalIsOpen: false,
            newPassword: null,
            verifyPassword: null,
            validPassword: false,
            passwordMatches: false,
            sendEmail: false,
            selectedUser: null
        };
    }

    componentDidMount() {
      this.props.getUsers({
          filters: {},
          projection: 'name surname email status',
          options: {},
          deleteVirtuals: true
      });
    };

    componentWillUnmount() {
        this.props.cleanUsers();
    }

    getUser = (userId) => {
        const { users } = this.props;
        const index = users.findIndex( user => user.get('_id') === userId );

        return users.get(index);
    };

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue,
            ...(inputName === 'newPassword') ? { validPassword: inputValue.length > 5 } : {},
            ...(inputName === 'newPassword') ? { passwordMatches: inputValue === this.state.verifyPassword } : {},
            ...(inputName === 'verifyPassword') ? { passwordMatches: inputValue === this.state.newPassword } : {}
        }, () => {
            this.setState({
                canSubmit:
                    this.state.newPassword &&
                    this.state.verifyPassword &&
                    this.state.newPassword.length > 5 &&
                    this.state.newPassword === this.state.verifyPassword
            });
        });
    };

    // Modal Handlers
    openModal = () => {
        this.setState({
            modalIsOpen: true
        });
    };
    closeModal = () => {

        this.setState({
            modalIsOpen: false,
            canSubmit: false
        })
    };

    render() {

        const { users, history } = this.props;
        const {
            usersFilter,
            modalIsOpen,
            canSubmit,
            newPassword,
            verifyPassword,
            validPassword,
            passwordMatches,
            sendEmail,
            selectedUser
        } = this.state;

        // Users Table
        let tableData = users;
        switch (usersFilter) {
            case 'active':
                tableData = users.filter( user => user.get('status') === 'active' );
                break;
            case 'inactive':
                tableData = users.filter( user => user.get('status') === 'inactive' );
                break;
            default :
                break;
        }
        let tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            name: {
                title: "Nombre",
                columnType: 'function',
                dataField: '_id',
                width: 200,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (userId) => {
                    const user = this.getUser(userId);

                    return <Link to={ '/usuarios/' + user.get('_id') }>{ user.get('name') }</Link>
                }
            },
            surname: {
                title: "Apellidos",
                columnType: 'function',
                dataField: '_id',
                width: 200,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (userId) => {
                    const user = this.getUser(userId);

                    return <Link to={ '/usuarios/' + user.get('_id') }>{ user.get('surname') }</Link>
                }
            },
            email: {
                title: "Email",
                columnType: 'text',
                dataField: 'email',
                width: 200,
                style: {},
                sortable: false,
                filterable: false
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (userId) => {
                    const user = this.getUser(userId);
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => history.push('/usuarios/' + user.get('_id'))} />
                            <MenuItem icon="key" text="Cambiar contraseña" onClick={ () => {
                                this.setState({ selectedUser: user }, this.openModal);
                            }} />
                            { user && user.get('status') === 'active'
                                ? <MenuItem onClick={ () => this.props.changeUserStatus(userId, 'inactive') } icon="eye-off" text="Desactivar" />
                                : user && user.get('status') === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeUserStatus(userId, 'active') } icon="eye-open" text="Activar" />
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Change Password Dialog
        let modal = null;
        if (modalIsOpen) {
            modal = {
                width: 'small',
                title: 'Cambiar contraseña',
                body: (
                    <UserChangePasswordDialog
                        fullName={selectedUser.get('full_name')}
                        newPassword={newPassword}
                        verifyPassword={verifyPassword}
                        validPassword={validPassword}
                        passwordMatches={passwordMatches}
                        sendEmail={sendEmail}
                        onChangeInput={this.onChangeInput}
                    />
                ),
                footer: (
                    <div className="modal-footer">
                        <button
                            key="cancel"
                            type="button"
                            className="btn btn-cancel"
                            label={'Cancelar'}
                            style={{
                                color: 'gray',
                                marginRight: 15
                            }}
                            onClick={this.closeModal}
                        >
                            {'Cancelar'}
                        </button>
                        <button
                            key="accept"
                            type="button"
                            className="btn btn-primary"
                            onClick={ () => {
                                this.props.changeUserPassword(selectedUser.get('_id'), {
                                    newPassword,
                                    verifyPassword,
                                    sendEmail
                                });
                                this.closeModal();
                            }}
                            disabled={!canSubmit}
                        >
                            {'Cambiar contraseña'}
                        </button>
                    </div>
                )
            };
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Usuarios</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => history.push('/usuarios/nuevo') } > <Icon icon="insert"/>Usuario</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { users instanceof List
                        ? <div className="row stats-zone" style={{ marginBottom: 20 }} >
                            <div className="col-auto">
                                <span className="label ">{ users.size }</span>
                                <span className="handPointer" onClick={ () => this.setState({ usersFilter: '' }) } >Total</span>
                            </div>
                            <div className="col-auto">
                                <span className="label label-primary">{ users.count(user => user.get('status') === 'active') }</span>
                                <span className="handPointer" onClick={ () => this.setState({ usersFilter: 'active' }) } >Activos</span>
                            </div>
                            <div className="col-auto">
                                <span className="label label-danger">{ users.count(user => user.get('status') === 'inactive') }</span>
                                <span className="handPointer" onClick={ () => this.setState({ usersFilter: 'inactive' }) } >Inactivos</span>
                            </div>
                        </div>
                        : null
                    }
                    <div className="row">
                        <div className="col">

                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    { modalIsOpen && (
                        <Modal
                            width={modal.width}
                            heading={modal.title}
                            footer={() => modal.footer}
                            autoFocus={false}
                            onClose={this.closeModal}
                        >
                            {modal.body}
                        </Modal>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const usersReducer = state.users;

    // Users
    const users = usersReducer.get('payload') || List([]);

    return {
        users
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: (query) => dispatch(getUsers(query)),
        changeUserStatus: (userId, status) => dispatch(changeUserStatus(userId, status)),
        changeUserPassword: (userId, passwordObject) => dispatch(changeUserPassword(userId, passwordObject)),
        cleanUsers: () => dispatch(cleanUsers())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);


// WEBPACK FOOTER //
// ./src/containers/configuration/users/UsersPage.js